import axios from 'axios';

import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';

const API_ROOT = '/api/v1/accounts/';

export async function editOrganization(
  accountId: number,
  name: string,
  organizationId: number,
): Promise<ApiBaseResponse> {
  const response = await axios.put<ApiBaseResponse>(
    `${API_ROOT}${accountId}/organizations/${organizationId}`,
    {
      name,
    },
  );

  if (!response.data.success) {
    throw new Error();
  }

  return response.data;
}
